import { type EditorView } from 'prosemirror-view'
import { findNodeByBlockId } from '../utils/findNodeByBlockId'

export const deleteNodeByBlockId = (blockId: string) => {
  return (view: EditorView) => {
    const { state, dispatch } = view
    const { tr } = state
    const nodeWithPos = findNodeByBlockId(state.doc, blockId)
    if (nodeWithPos) {
      tr.delete(nodeWithPos.pos, nodeWithPos.pos + nodeWithPos.node.nodeSize)
      dispatch?.(tr)
      return true
    }
    return false
  }
}
